import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-3 relative z-10" }

import { ComboboxOption } from "@headlessui/vue";
import { CheckIcon } from "@heroicons/vue/24/solid";
import { computed, PropType } from "vue";
import { UnitValueTypeWithChildren } from "@/types/UnitValue";
import ColumnModalTypeFieldListOption from "@/views/unitValues/ColumnModalTypeFieldListOption.vue";

const itemHeight = 32;


export default /*#__PURE__*/_defineComponent({
  __name: 'ColumnModalTypeFieldListOption',
  props: {
  existingTypes: {
    type: Array as PropType<string[]>,
    required: true,
  },
  typeWithChildren: {
    type: Object as PropType<UnitValueTypeWithChildren>,
    required: true,
  },
  parent: {
    type: Object as PropType<UnitValueTypeWithChildren | null>,
    required: false,
  },
  parentChildren: {
    type: Object as PropType<UnitValueTypeWithChildren[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const countItems = <T extends { children: T[] }>(items: T[]) => {
  let count = 0;
  for (const item of items) {
    count += countItems(item.children) + 1;
  }
  return count;
};

const countOfItemsBefore = computed(() => {
  const index = props.parentChildren.indexOf(props.typeWithChildren);
  if (index < 0) {
    return 0;
  }
  return countItems(props.parentChildren.slice(0, index)) + (props.parent ? 1 : 0);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ComboboxOption), {
      as: "template",
      value: __props.typeWithChildren.type,
      disabled: __props.existingTypes.includes(__props.typeWithChildren.type)
    }, {
      default: _withCtx(({ active, selected, disabled }) => [
        _createElementVNode("li", {
          class: _normalizeClass(["relative cursor-default select-none py-2 pl-5 pr-9 z-20", {
        'bg-yellow-600 text-white': active,
        'text-gray-200': !active && disabled,
        'text-gray-900': !active && !disabled,
      }])
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["text-xs block truncate", 
          __props.typeWithChildren.matchType === 'label' || selected ? ['font-semibold'] : ['font-normal']
        ])
          }, _toDisplayString(__props.typeWithChildren.label), 3),
          selected
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass([
          active ? 'text-white' : 'text-yellow-600',
          'absolute inset-y-0 right-0 flex items-center pr-4',
        ])
              }, [
                _createVNode(_unref(CheckIcon), {
                  class: "h-5 w-5",
                  "aria-hidden": "true"
                })
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["absolute border-b top-1/2", active ? ['border-yellow-600'] : ['border-gray-600']]),
            style: _normalizeStyle(`${__props.parent ? 'left: -3px; width: 19px' : 'left: 9px; width: 7px'}`)
          }, null, 6),
          (__props.parent)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "absolute border-l border-gray-600 bottom-1/2",
                style: _normalizeStyle(`left: -3px; height: ${countOfItemsBefore.value * itemHeight}px`)
              }, null, 4))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["value", "disabled"]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.typeWithChildren.children, (childType) => {
        return (_openBlock(), _createBlock(ColumnModalTypeFieldListOption, {
          existingTypes: __props.existingTypes,
          key: childType.type,
          typeWithChildren: childType,
          parent: __props.typeWithChildren,
          parentChildren: __props.typeWithChildren.children
        }, null, 8, ["existingTypes", "typeWithChildren", "parent", "parentChildren"]))
      }), 128))
    ])
  ], 64))
}
}

})